// extracted by mini-css-extract-plugin
export default {"after-action-close-icon":"PlayVideo_after-action-close-icon_Cryt7","after-action-tips-page":"PlayVideo_after-action-tips-page_JmmU_"};